// extracted by mini-css-extract-plugin
export default {"input":"FileUpload-module__input___CIw0g"};